export class DynamicTableColumn {
  key: string;
  label: string;
  isSortable?: boolean;
  sortOrder?: string;
}
